// Fills the general settings form with provided data
export const generalSettingsFillForm = (data) => ({
  WebsiteLogoUrl: "",
  WebsiteMainBanner: "",
  CompleteProjectLogoUrl: "",
  EnableFastDonation: data.enableFastDonation,
  EnableWhatsAppChat: data.enableWhatsAppChat,
  ShowApplePayMessage: data.showApplePayMessage,
  WebsiteLogoLink: data?.websiteLogoFullUrl || "",
  MotivationalSentence: data.motivationalSentence,
  MinAmountForDonations: data.minAmountForDonations,
  WebsiteMainBannerLink: data?.websiteMainBanner || "",
  NameMandatoryWhileLogin: data.nameMandatoryWhileLogin,
  MinAmountForFastDonation: data.minAmountForFastDonation,
  HideBankAccountFromDonation: data.hideBankAccountFromDonation,
  CompleteProjectLogoLink: data?.completeProjectLogoFullUrl || "",
  SmsVerificationWhenLogin: data.smsVerificationWhenLogin,
});

export const generalSettingsPayload = (data) => ({
  WebsiteLogoUrl: data.WebsiteLogoUrl,
  CompleteProjectLogoUrl: data.CompleteProjectLogoUrl,
  WebsiteMainBanner: data.WebsiteMainBanner,
  MotivationalSentence: data.MotivationalSentence,
  MinAmountForDonations: data.MinAmountForDonations,
  EnableFastDonation: data.EnableFastDonation,
  EnableWhatsAppChat: data.EnableWhatsAppChat,
  ShowApplePayMessage: data.ShowApplePayMessage,
  MinAmountForFastDonation: data.MinAmountForFastDonation,
  NameMandatoryWhileLogin: data.NameMandatoryWhileLogin,
  HideBankAccountFromDonation: data.HideBankAccountFromDonation,
  SmsVerificationWhenLogin: data.SmsVerificationWhenLogin,
});
